import { useState, useEffect } from "react";
import { supabase } from '../../../../../supabase';
import { v4 as uuidv4 } from 'uuid';
import LibraryModal from '../../../../../components/LibraryModal';

export default function BlockImage({ block, updateBlock }) {
    const [image, setImage] = useState(block.src || "");
    const [label, setLabel] = useState(block.label || "");
    const [showLibraryModal, setShowLibraryModal] = useState(false);

    function handleImageSelect(imageUrl, media) {
        setImage(imageUrl);
        block.src = imageUrl; 
        const imageElement = document.getElementById(`image-${block.id}`);
        if (imageElement) {
            imageElement.src = imageUrl;
        }
        setShowLibraryModal(false);
    }

    function handleImageWidthChange(e){
        block.imageWidth = e.target.value;
        updateBlock(block.id, 'imageWidth', e.target.value);
    }

    function handleImageAlignmentChange(e){
        block.imageAlignment = e.target.value;
        updateBlock(block.id, 'imageAlignment', e.target.value);
    }

    return (
        <div> 
            <label className="block font-semibold mb-2 w-full">Configuração de Imagem:</label>
            <div className="p-2 bg-gray-100 rounded w-full">
                <button
                    type="button"
                    className="w-full p-3 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                    onClick={() => setShowLibraryModal(true)}
                >
                    Escolher/Upload de Imagem
                </button>
                
                {image && (
                    <div className="mt-4">
                        <p className="text-sm text-gray-600 mb-2">Imagem atual:</p>
                        <img 
                            src={image} 
                            alt="Preview" 
                            className="w-full max-w-xs object-cover rounded border"
                        />

                        <p className="text-sm text-gray-600 mb-2">Largura da imagem:</p>
                        <input
                            type="range"
                            className="w-full"
                            min={1}
                            max={100}
                            value={block.imageWidth}
                            onChange={handleImageWidthChange}
                        />
                        <select className="w-full p-2 rounded" value={block.imageAlignment} onChange={handleImageAlignmentChange}>
                            <option value="left">Esquerda</option>
                            <option value="center">Centro</option>
                            <option value="right">Direita</option>
                        </select>
                    </div>

                    
                )}
            </div>

            <LibraryModal
                open={showLibraryModal}
                onClose={() => setShowLibraryModal(false)}
                onSelect={handleImageSelect}
            />
        </div>
    );
}